import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slices/userSlice";
import mapReducer from "./slices/mapSlice";
import loaderReducer from "./slices/loaderSlice";
import mapSettingsReducer from "./slices/mapSettingsSlice";
import toastReducer from "./slices/toastSlice";

const store = configureStore({
  reducer: {
    loader: loaderReducer,
    toast: toastReducer,
    user: userReducer,
    map: mapReducer,
    mapSettings: mapSettingsReducer,
  },
});

export default store;
